import { Divider, Group, IconFont } from '@byecode/ui'
import type { SchemaProtocol } from '@lighthouse/core'
import type { ChartType } from '@lighthouse/core'
import { areaChartType } from '@lighthouse/shared'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import styled from 'styled-components'

import { DimensionSetting } from '../DimensionSetting'
import type { ChartFormSlice } from '../formSlice'

const ChartConfigurator = styled.div``

const SCxIcon = styled(IconFont)`
    color: var(--color-gray-500);
    &:hover {
        color: var(--color-gray-900);
    }
`

interface DimensionConfiguratorProps {
    dsId: string
    schema: SchemaProtocol['schema']
}

export const DimensionConfigurator: React.FC<DimensionConfiguratorProps> = ({ dsId, schema }) => {
    const { control } = useFormContext<ChartFormSlice>()
    const chartType = (useWatch({ control, name: 'chartType' }) ?? 'bar') as ChartType

    const isAreaChart = areaChartType.has(chartType)
    const dimensions = useWatch({ control, name: 'dimensions' }) ?? []
    const mainAxis = useWatch({ control, name: 'mainAxis' }) ?? []
    // const enableHierarchy = useWatch({ control, name: 'enableHierarchy' })
    const enableDimensions = (isAreaChart && dimensions.length === 0 && mainAxis.length < 2) || !isAreaChart
    // const showHierarchy = (!isPieChart && dimensions.length > 0) || (isPieChart && dimensions.length === 1 )
    return (
        <>
            <Divider color="var(--color-gray-200)" />
            <Group label="维度">
                <ChartConfigurator>
                    <Controller
                        control={control}
                        name="dimensions"
                        render={({ field }) => (
                            <DimensionSetting
                                dsId={dsId}
                                value={field.value ?? []}
                                onChange={field.onChange}
                                disableAdd={!enableDimensions}
                                // limitIds={hierarchies?.map(({ fieldId }) => fieldId)}
                                type={chartType}
                                schema={schema}
                            />
                        )}
                    />
                </ChartConfigurator>
            </Group>
        </>
    )
}
